import "react";
import { jsx as o, jsxs as n } from "react/jsx-runtime";
var t = (e) => /* @__PURE__ */ n("svg", {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [
    /* @__PURE__ */ o("circle", {
      cx: 20,
      cy: 20,
      r: 15.0062,
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ o("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.3326 25.8358H22.1831Z"
    }),
    /* @__PURE__ */ o("path", {
      d: "M18.3326 25.8358H22.1831",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ o("path", {
      d: "M20.2651 25.8357V18.7495H18.3476",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ o("path", {
      d: "M20.1667 13.7428C20.1667 13.973 19.9801 14.1596 19.7499 14.1596C19.5197 14.1596 19.333 13.973 19.333 13.7428C19.333 13.5126 19.5197 13.326 19.7499 13.326",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ o("path", {
      d: "M19.7499 13.3259C19.9801 13.3259 20.1667 13.5126 20.1667 13.7428",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  ]
});
export {
  t as default
};

//# sourceMappingURL=DialogInfo.js.map